export default __webpack_public_path__ + "static/media/empty.35238df2.png";